var map = {
	"./blue_circle.png": 1126,
	"./green_circle.png": 1127,
	"./orange_circle.png": 1128,
	"./purple_circle.png": 1129,
	"./red_circle.png": 1130,
	"./yellow_circle.png": 1131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1125;


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img ^\.\/.*_circle\.png$
// module id = 1125
// module chunks = 0